import userDetails from "./dataset/userDetails.json";

export default userDetails;
